/* tslint:disable */

// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const userUpdateMe = /* GraphQL */ `mutation UserUpdateMe($input: UserUpdateInput!) {
  userUpdateMe(input: $input)
}
` as GeneratedMutation<APITypes.UserUpdateMeMutationVariables, APITypes.UserUpdateMeMutation>;
export const userDelete = /* GraphQL */ `mutation UserDelete($id: ID!) {
  userDelete(id: $id)
}
` as GeneratedMutation<APITypes.UserDeleteMutationVariables, APITypes.UserDeleteMutation>;
export const userUpdateHostData =
  /* GraphQL */ `mutation UserUpdateHostData($input: UserUpdateHostDataInput!) {
  userUpdateHostData(input: $input) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UserUpdateHostDataMutationVariables,
    APITypes.UserUpdateHostDataMutation
  >;
export const userCreate = /* GraphQL */ `mutation UserCreate($input: UserCreateInput!) {
  userCreate(input: $input) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UserCreateMutationVariables, APITypes.UserCreateMutation>;
export const userUpdate = /* GraphQL */ `mutation UserUpdate($id: ID!, $input: UserUpdateInput!) {
  userUpdate(id: $id, input: $input) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.UserUpdateMutationVariables, APITypes.UserUpdateMutation>;
export const userUpdateStatus =
  /* GraphQL */ `mutation UserUpdateStatus($sub: String!, $input: UserUpdateInput!) {
  userUpdateStatus(sub: $sub, input: $input) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.UserUpdateStatusMutationVariables,
    APITypes.UserUpdateStatusMutation
  >;
export const userResendInvite =
  /* GraphQL */ `mutation UserResendInvite($email: String!, $isAdmin: Boolean!) {
  userResendInvite(email: $email, isAdmin: $isAdmin)
}
` as GeneratedMutation<
    APITypes.UserResendInviteMutationVariables,
    APITypes.UserResendInviteMutation
  >;
export const sessionCreate = /* GraphQL */ `mutation SessionCreate($input: SessionCreateInput!) {
  sessionCreate(input: $input) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.SessionCreateMutationVariables, APITypes.SessionCreateMutation>;
export const sessionNextRound = /* GraphQL */ `mutation SessionNextRound($id: ID!) {
  sessionNextRound(id: $id) {
    round
    sessionStatus
    playerStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SessionNextRoundMutationVariables,
  APITypes.SessionNextRoundMutation
>;
export const sessionEnd = /* GraphQL */ `mutation SessionEnd($id: ID!) {
  sessionEnd(id: $id) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.SessionEndMutationVariables, APITypes.SessionEndMutation>;
export const sessionSetEnding = /* GraphQL */ `mutation SessionSetEnding($id: ID!) {
  sessionSetEnding(id: $id) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SessionSetEndingMutationVariables,
  APITypes.SessionSetEndingMutation
>;
export const sessionSetSharing =
  /* GraphQL */ `mutation SessionSetSharing($id: ID!, $playerId: ID!) {
  sessionSetSharing(id: $id, playerId: $playerId) {
    playerId
    __typename
  }
}
` as GeneratedMutation<
    APITypes.SessionSetSharingMutationVariables,
    APITypes.SessionSetSharingMutation
  >;
export const playerJoin =
  /* GraphQL */ `mutation PlayerJoin($id: ID!, $name: String!, $feelingBefore: Int!) {
  playerJoin(id: $id, name: $name, feelingBefore: $feelingBefore) {
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    newPlayer {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<APITypes.PlayerJoinMutationVariables, APITypes.PlayerJoinMutation>;
export const playerUpdateSentiment = /* GraphQL */ `mutation PlayerUpdateSentiment(
  $id: ID!
  $playerId: ID!
  $sentiment: Int!
  $isBefore: Boolean!
) {
  playerUpdateSentiment(
    id: $id
    playerId: $playerId
    sentiment: $sentiment
    isBefore: $isBefore
  ) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlayerUpdateSentimentMutationVariables,
  APITypes.PlayerUpdateSentimentMutation
>;
export const playerUpdateQuestion = /* GraphQL */ `mutation PlayerUpdateQuestion(
  $id: ID!
  $playerId: ID!
  $question: String!
  $answer: Boolean!
) {
  playerUpdateQuestion(
    id: $id
    playerId: $playerId
    question: $question
    answer: $answer
  ) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlayerUpdateQuestionMutationVariables,
  APITypes.PlayerUpdateQuestionMutation
>;
export const playerSubmitDrawing =
  /* GraphQL */ `mutation PlayerSubmitDrawing($id: ID!, $playerId: ID!, $drawing: String!) {
  playerSubmitDrawing(id: $id, playerId: $playerId, drawing: $drawing) {
    id
    drawing
    playerId
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PlayerSubmitDrawingMutationVariables,
    APITypes.PlayerSubmitDrawingMutation
  >;
export const playerReact = /* GraphQL */ `mutation PlayerReact(
  $id: ID!
  $playerId: ID!
  $artworkId: ID!
  $reaction: String!
) {
  playerReact(
    id: $id
    playerId: $playerId
    artworkId: $artworkId
    reaction: $reaction
  ) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PlayerReactMutationVariables, APITypes.PlayerReactMutation>;
export const gamePackCreate = /* GraphQL */ `mutation GamePackCreate(
  $name: String!
  $description: String!
  $icon: GamePackIcon!
  $palette: GamePackPalette!
  $category1: String
  $category2: String
  $category3: String
  $isFeatured: Boolean
  $showInDiscover: Boolean
  $isNew: Boolean
  $groups: [String!]
  $status: GamePackStatus
  $organizationIds: [ID!]
) {
  gamePackCreate(
    name: $name
    description: $description
    icon: $icon
    palette: $palette
    category1: $category1
    category2: $category2
    category3: $category3
    isFeatured: $isFeatured
    showInDiscover: $showInDiscover
    isNew: $isNew
    groups: $groups
    status: $status
    organizationIds: $organizationIds
  ) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GamePackCreateMutationVariables, APITypes.GamePackCreateMutation>;
export const gamePackUpdate = /* GraphQL */ `mutation GamePackUpdate(
  $id: ID!
  $name: String!
  $description: String!
  $icon: GamePackIcon!
  $palette: GamePackPalette!
  $category1: String
  $category2: String
  $category3: String
  $isFeatured: Boolean
  $showInDiscover: Boolean
  $isNew: Boolean
  $groups: [String!]
  $status: GamePackStatus
  $organizationIds: [ID!]
) {
  gamePackUpdate(
    id: $id
    name: $name
    description: $description
    icon: $icon
    palette: $palette
    category1: $category1
    category2: $category2
    category3: $category3
    isFeatured: $isFeatured
    showInDiscover: $showInDiscover
    isNew: $isNew
    groups: $groups
    status: $status
    organizationIds: $organizationIds
  ) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GamePackUpdateMutationVariables, APITypes.GamePackUpdateMutation>;
export const gamePackUpdateOrder =
  /* GraphQL */ `mutation GamePackUpdateOrder($orders: [GamePackOrderInput!]!) {
  gamePackUpdateOrder(orders: $orders) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GamePackUpdateOrderMutationVariables,
    APITypes.GamePackUpdateOrderMutation
  >;
export const gamePackAddPrompt =
  /* GraphQL */ `mutation GamePackAddPrompt($id: ID!, $promptId: ID!) {
  gamePackAddPrompt(id: $id, promptId: $promptId) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GamePackAddPromptMutationVariables,
    APITypes.GamePackAddPromptMutation
  >;
export const gamePackRemovePrompt =
  /* GraphQL */ `mutation GamePackRemovePrompt($id: ID!, $promptId: ID!) {
  gamePackRemovePrompt(id: $id, promptId: $promptId) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GamePackRemovePromptMutationVariables,
    APITypes.GamePackRemovePromptMutation
  >;
export const gamePackDelete = /* GraphQL */ `mutation GamePackDelete($id: ID!) {
  gamePackDelete(id: $id) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GamePackDeleteMutationVariables, APITypes.GamePackDeleteMutation>;
export const promptCreate =
  /* GraphQL */ `mutation PromptCreate($text: String!, $subdomain: String) {
  promptCreate(text: $text, subdomain: $subdomain) {
    id
    text
    subdomain
    deletedAt
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PromptCreateMutationVariables, APITypes.PromptCreateMutation>;
export const promptUpdate =
  /* GraphQL */ `mutation PromptUpdate($id: ID!, $text: String!, $subdomain: String) {
  promptUpdate(id: $id, text: $text, subdomain: $subdomain) {
    id
    text
    subdomain
    deletedAt
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PromptUpdateMutationVariables, APITypes.PromptUpdateMutation>;
export const promptDelete = /* GraphQL */ `mutation PromptDelete($id: ID!) {
  promptDelete(id: $id) {
    id
    text
    subdomain
    deletedAt
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PromptDeleteMutationVariables, APITypes.PromptDeleteMutation>;
export const organizationCreate =
  /* GraphQL */ `mutation OrganizationCreate($input: OrganizationCreateInput!) {
  organizationCreate(input: $input) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.OrganizationCreateMutationVariables,
    APITypes.OrganizationCreateMutation
  >;
export const organizationUpdate =
  /* GraphQL */ `mutation OrganizationUpdate($id: ID!, $input: OrganizationUpdateInput!) {
  organizationUpdate(id: $id, input: $input) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.OrganizationUpdateMutationVariables,
    APITypes.OrganizationUpdateMutation
  >;
export const organizationDelete = /* GraphQL */ `mutation OrganizationDelete($id: ID!) {
  organizationDelete(id: $id) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.OrganizationDeleteMutationVariables,
  APITypes.OrganizationDeleteMutation
>;
export const organizationAddUser =
  /* GraphQL */ `mutation OrganizationAddUser($organizationId: ID!, $userId: ID!) {
  organizationAddUser(organizationId: $organizationId, userId: $userId) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.OrganizationAddUserMutationVariables,
    APITypes.OrganizationAddUserMutation
  >;
export const organizationInviteUser =
  /* GraphQL */ `mutation OrganizationInviteUser($input: UserInviteInput!) {
  organizationInviteUser(input: $input) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.OrganizationInviteUserMutationVariables,
    APITypes.OrganizationInviteUserMutation
  >;
export const playerCreate = /* GraphQL */ `mutation PlayerCreate($input: PlayerCreateInput!) {
  playerCreate(input: $input) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PlayerCreateMutationVariables, APITypes.PlayerCreateMutation>;
export const playerUpdate =
  /* GraphQL */ `mutation PlayerUpdate($id: ID!, $input: PlayerUpdateInput!) {
  playerUpdate(id: $id, input: $input) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.PlayerUpdateMutationVariables, APITypes.PlayerUpdateMutation>;
export const playerDelete = /* GraphQL */ `mutation PlayerDelete($id: ID!) {
  playerDelete(id: $id)
}
` as GeneratedMutation<APITypes.PlayerDeleteMutationVariables, APITypes.PlayerDeleteMutation>;
export const playerUpdateConnectionStatus = /* GraphQL */ `mutation PlayerUpdateConnectionStatus(
  $id: ID!
  $connectionStatus: PlayerConnectionStatus!
) {
  playerUpdateConnectionStatus(id: $id, connectionStatus: $connectionStatus) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlayerUpdateConnectionStatusMutationVariables,
  APITypes.PlayerUpdateConnectionStatusMutation
>;
export const playerUpdateGameStatus =
  /* GraphQL */ `mutation PlayerUpdateGameStatus($id: ID!, $gameStatus: PlayerGameStatus!) {
  playerUpdateGameStatus(id: $id, gameStatus: $gameStatus) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PlayerUpdateGameStatusMutationVariables,
    APITypes.PlayerUpdateGameStatusMutation
  >;
export const gameCreate = /* GraphQL */ `mutation GameCreate($input: GameCreateInput!) {
  gameCreate(input: $input) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GameCreateMutationVariables, APITypes.GameCreateMutation>;
export const gameUpdate = /* GraphQL */ `mutation GameUpdate($id: ID!, $input: GameUpdateInput!) {
  gameUpdate(id: $id, input: $input) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GameUpdateMutationVariables, APITypes.GameUpdateMutation>;
export const gameDelete = /* GraphQL */ `mutation GameDelete($id: ID!) {
  gameDelete(id: $id)
}
` as GeneratedMutation<APITypes.GameDeleteMutationVariables, APITypes.GameDeleteMutation>;
export const gameUpdateStatus =
  /* GraphQL */ `mutation GameUpdateStatus($id: ID!, $status: GameStatus!) {
  gameUpdateStatus(id: $id, status: $status) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GameUpdateStatusMutationVariables,
    APITypes.GameUpdateStatusMutation
  >;
export const gameSetCurrent = /* GraphQL */ `mutation GameSetCurrent($id: ID!) {
  gameSetCurrent(id: $id) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GameSetCurrentMutationVariables, APITypes.GameSetCurrentMutation>;
export const gameSetLast = /* GraphQL */ `mutation GameSetLast($id: ID!) {
  gameSetLast(id: $id) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.GameSetLastMutationVariables, APITypes.GameSetLastMutation>;
export const playerCardCreate =
  /* GraphQL */ `mutation PlayerCardCreate($input: PlayerCardCreateInput!) {
  playerCardCreate(input: $input) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PlayerCardCreateMutationVariables,
    APITypes.PlayerCardCreateMutation
  >;
export const playerCardUpdate =
  /* GraphQL */ `mutation PlayerCardUpdate($id: ID!, $input: PlayerCardUpdateInput!) {
  playerCardUpdate(id: $id, input: $input) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PlayerCardUpdateMutationVariables,
    APITypes.PlayerCardUpdateMutation
  >;
export const playerCardDelete = /* GraphQL */ `mutation PlayerCardDelete($id: ID!) {
  playerCardDelete(id: $id)
}
` as GeneratedMutation<
  APITypes.PlayerCardDeleteMutationVariables,
  APITypes.PlayerCardDeleteMutation
>;
export const playerCardUpdateDrawing = /* GraphQL */ `mutation PlayerCardUpdateDrawing(
  $id: ID!
  $drawing: String!
  $drawingLines: String
) {
  playerCardUpdateDrawing(
    id: $id
    drawing: $drawing
    drawingLines: $drawingLines
  ) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlayerCardUpdateDrawingMutationVariables,
  APITypes.PlayerCardUpdateDrawingMutation
>;
export const playerCardIncrementReaction =
  /* GraphQL */ `mutation PlayerCardIncrementReaction($id: ID!, $type: ReactionType!) {
  playerCardIncrementReaction(id: $id, type: $type) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.PlayerCardIncrementReactionMutationVariables,
    APITypes.PlayerCardIncrementReactionMutation
  >;
export const gamePackPromptsCreate =
  /* GraphQL */ `mutation GamePackPromptsCreate($input: GamePackPromptsCreateInput!) {
  gamePackPromptsCreate(input: $input) {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GamePackPromptsCreateMutationVariables,
    APITypes.GamePackPromptsCreateMutation
  >;
export const gamePackPromptsUpdate =
  /* GraphQL */ `mutation GamePackPromptsUpdate($id: ID!, $input: GamePackPromptsUpdateInput!) {
  gamePackPromptsUpdate(id: $id, input: $input) {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
    APITypes.GamePackPromptsUpdateMutationVariables,
    APITypes.GamePackPromptsUpdateMutation
  >;
export const gamePackPromptsDelete = /* GraphQL */ `mutation GamePackPromptsDelete($id: ID!) {
  gamePackPromptsDelete(id: $id)
}
` as GeneratedMutation<
  APITypes.GamePackPromptsDeleteMutationVariables,
  APITypes.GamePackPromptsDeleteMutation
>;
export const gamePackOrganizationsCreate = /* GraphQL */ `mutation GamePackOrganizationsCreate(
  $input: GamePackOrganizationsCreateInput!
) {
  gamePackOrganizationsCreate(input: $input) {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GamePackOrganizationsCreateMutationVariables,
  APITypes.GamePackOrganizationsCreateMutation
>;
export const gamePackOrganizationsUpdate = /* GraphQL */ `mutation GamePackOrganizationsUpdate(
  $id: ID!
  $input: GamePackOrganizationsUpdateInput!
) {
  gamePackOrganizationsUpdate(id: $id, input: $input) {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GamePackOrganizationsUpdateMutationVariables,
  APITypes.GamePackOrganizationsUpdateMutation
>;
export const gamePackOrganizationsDelete =
  /* GraphQL */ `mutation GamePackOrganizationsDelete($id: ID!) {
  gamePackOrganizationsDelete(id: $id)
}
` as GeneratedMutation<
    APITypes.GamePackOrganizationsDeleteMutationVariables,
    APITypes.GamePackOrganizationsDeleteMutation
  >;
export const artworkReactionCreate =
  /* GraphQL */ `mutation ArtworkReactionCreate($input: ArtworkReactionCreateInput!) {
  artworkReactionCreate(input: $input) {
    reaction
    playerCardId
    playerId
    sessionId
    __typename
  }
}
` as GeneratedMutation<
    APITypes.ArtworkReactionCreateMutationVariables,
    APITypes.ArtworkReactionCreateMutation
  >;
export const startAsyncTask = /* GraphQL */ `mutation StartAsyncTask($input: AsyncTaskInput!) {
  startAsyncTask(input: $input) {
    id
    type
    status
    payload
    result
    error
    createdBy
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<APITypes.StartAsyncTaskMutationVariables, APITypes.StartAsyncTaskMutation>;
